"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    root: {
        display: 'flex',
        flexGrow: 1,
        zIndex: 1
    }
};
//# sourceMappingURL=select.style.js.map